import React, { useState, useMemo, useEffect } from "react";
import {
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    ListSubheader,
    TextField,
    InputAdornment
} from "@mui/material/";
import SearchIcon from "@mui/icons-material/Search";
import { strings } from "../../i18n";

export default ({ label, data, currentValue, onChangeFn }) => {
    const [searchText, setSearchText] = useState("");

    /** Search Text  */
    const containsText = (text, searchText) =>
        text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

    /** Display based on the searchResult */
    const searchList = useMemo(() => {
        return data.filter((option) => containsText(option, searchText));
    }, [data, searchText]);

    /** On change value of select */
    const onSelectChange = (evt) => onChangeFn && onChangeFn(evt.target.value);

    return (
        <FormControl fullWidth variant="standard">
            <InputLabel id="search-select-label">{label}</InputLabel>
            <Select
                size="small"
                MenuProps={{ autoFocus: false }}
                labelId={`search-select-label-${label}`}
                id={`search-select-${label}`}
                value={currentValue}
                label={label}
                onChange={onSelectChange}
                onClose={() => setSearchText("")}
                renderValue={() => currentValue}
            >
                <ListSubheader style={{ background: "white" }}>
                    <TextField
                        variant="standard"
                        size="small"
                        autoFocus
                        placeholder={strings("search")}
                        fullWidth
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            )
                        }}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key !== "Escape") {
                                e.stopPropagation();
                                // Preventing  autoselecting item while typing (default Select behaviour)
                            }
                        }}
                    />
                </ListSubheader>
                {searchList.map((option, i) => (
                    <MenuItem key={i} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
